export default [
  {
    title: 'Administração',
    i18n: 'Admin',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Clientes',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            i18n: 'Clients',
            route: 'admin-user-client',
          },
          {
            title: 'Contatos',
            i18n: 'Contact',
            route: 'admin-contact',
          },
        ],
      },
    ],
  },
]
